import WeddingForm from "./Form";
import { Button } from "@material-ui/core";
import { Reply } from "@material-ui/icons";
import React from "react";
import Classic from "./WeddingTemplates/Classic";
import Wreath from "./WeddingTemplates/Wreath";
import FloralFrame from "./WeddingTemplates/FloralFrame";
import Sakura from "./WeddingTemplates/Sakura";
import GoldDots from "./WeddingTemplates/GoldDots";
import GoldGlitter from "./WeddingTemplates/GoldGlitter";
import MarsalaFloral from "./WeddingTemplates/MarsalaFloral";
import SilverGlitter from "./WeddingTemplates/SilverGlitter";
import ModernMinimalist from "./WeddingTemplates/ModernMinimalist";
import BotanicalSage from "./WeddingTemplates/BotanicalSage";
import GildedArch from "./WeddingTemplates/GildedArch";
import CustomInvitation from "./WeddingTemplates/CustomInvitation";
import FormHeader from "../assets/resources/FormHeader";
import CustomWeddingForm from "./CustomForm";
import "./WeddingTemplates/CSS/Medias.css";

var converter = require('number-to-words');

class SideBySide extends React.Component {
   
  constructor(props) {
    super();
    // eslint-disable-next-line no-extend-native
    String.prototype.capitalize = function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    }
    this.template = props.template;
   
    this.brideParents = "Mr. and Mrs. Father LastName"
    this.groomParents = "Mr. and Mrs. Mother LastName"
    this.requestLine1 = "Request the honour of your presence"
    this.requestLine2 = "at the marriage of their children"
    this.womanName = 'Juliet'
    this.manName = 'Romeo'
    this.day = "Monday"
    this.date = 'the Twenty-ninth of November'
    this.year = "Two thousand and twenty one"
    this.time = "Five thirty in the evening"
    this.venue = "Kol Yaakov"
    this.venueForMaps = ''
    this.venueAddress = "1703 McDonald Avenue"
    this.cityState = "Brooklyn, New York"
    this.phone = " 1 (347) 280-3596"
    this.link = 'https://www.google.com/maps/search/?api=1&query=kol+yaakov'
    this.footerMessage1 = `Can't wait to celebrate auspicious moment of our family with you!`
    this.footerMessage2 = 'Just a ping away for any queries: 1 (347) 280-3596'
    this.endingNote = 'Join us in our happiness!'
    this.bottomLeft = 'Black Tie'
    this.bottomRight = "Ceremony promptly at 6:30 pm"
    this.changed = false;
    this.brideInitial = this.womanName.charAt(0).capitalize();
    this.groomInitial =  this.manName.charAt(0).capitalize();
    this.reqObject =
    {
      envelopeColor:"black",
      isSideBySide:true,
      loadingActive:false,
      customDesign:'',
      template: this.template,
      brideParents: this.brideParents,
      groomParents: this.groomParents,
      requestLine1: this.requestLine1,
      requestLine2: this.requestLine2,
      womanName: this.womanName,
      manName: this.manName,
      day: this.day,
      date: this.date,
      year: this.year,
      time: this.time,
      brideInitial : this.womanName.charAt(0).capitalize(),
      groomInitial :  this.manName.charAt(0).capitalize(),
      venue: this.venue,
      venueForMaps: this.venueForMaps,
      venueAddress: this.venueAddress,
      cityState: this.cityState,
      phone: this.phone,
      link: this.link,
      footerMessage1: this.footerMessage1,
      footerMessage2: this.footerMessage2,
      endingNote: this.endingNote,
      bottomLeft: this.bottomLeft,
      bottomRight: this.bottomRight,
      changed: this.changed,
      invitationType: "Wedding"
    }
    this.handleReqObject = this.handleReqObject.bind(this);
  }
  ChooseTemplate() {
    window.location.reload();
  }
  getHours(date) {
    return date.getHours() % 12 || 12;
  }
  handleReqObject = (value) => {
    // eslint-disable-next-line
    String.prototype.capitalize = function () {
      return this.charAt(0).toUpperCase() + this.slice(1);
    }


    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    var d = new Date(value.eventDate);
console.log('here2')
    var dayName = days[d.getDay()];
    var date = converter.toOrdinal(d.getUTCDate());
    console.log(value.eventDate)
    this.day = dayName;
    this.date = "the " + date + " of " + d.toLocaleString('default', { month: 'long' });
    this.year = converter.toWords(d.getFullYear()).split(',').join(' and ').capitalize();
    var hours = d.getHours();
    var ampm = hours >= 12 ? 'pm' : 'am';
    var timeOfDay = ampm.includes("am") ? "morning" : "evening";
    this.time = converter.toWords(this.getHours(d)) + " " + converter.toWords(d.getMinutes()) + " in the " + timeOfDay;
    var newTime = this.time.replace("zero", "o'clock");

    this.reqObject = {
      envelopeColor:value.envelopeColor,
      template: this.template,
      brideParents: value.brideParents,
      groomParents: value.groomParents,
      requestLine1: value.requestLine1,
      requestLine2: value.requestLine2,
      womanName: value.womanName,
      manName: value.manName,
       dayName :days[d.getDay()],
       date : "the " + date + " of " + d.toLocaleString('default', { month: 'long' }),
      
      day :dayName,
      //date : "the " + date + " of " + d.toLocaleString('default', { month: 'long' }),
      year : converter.toWords(d.getFullYear()).split(',').join(' and ').capitalize(),
      hours : d.getHours(),
      timeOfDay : ampm.includes("am") ? "morning" : "evening",
      time : newTime,
      loadingActive: value.loadingActive,
      venue: value.venue,
      venueForMaps: value.venueForMaps,
      venueAddress: value.venueAddress,
      cityState: value.cityState,
      phone: value.phone,
      link: value.link,
      footerMessage1: value.footerMessage1,
      footerMessage2: value.footerMessage2,
      endingNote: value.endingNote,
      bottomLeft: value.bottomLeft,
      bottomRight: value.bottomRight,
      changed: value.changed,
      invitationType: "Wedding",
      fontFamily: value.fontFamily,
      fontSize: value.fontSize
    }
    console.log('here3')

    this.setState((prevState, props) => ({
      changed: !value.changed,

    }));
    console.log(this.changed)
    console.log(this.reqObject.brideParents + 'ppppp')
  }
 
  render() {
    return (
      <div id="side-by-side-page" style = {{margin: 0,  padding: 0,width:"100%"}} >
         
        <FormHeader />
        <Button variant="contained" onClick={() => this.ChooseTemplate()} style={{ backgroundColor: "#1DAEE0", color: "white", margin:"10px"}} size="large" startIcon={<Reply />}>CHOOSE ANOTHER TEMPLATE</Button>
        <div className="text-center" >
          <div className="form-row" style={{ margin: 0 }}>
            <div className="col-md-5"></div>
            <div className="col-md text-center" style={{ padding: "8px" }}>
              <p style={{ color: "#444", fontStyle: "italic", fontSize: "1rem", margin: 0, fontWeight: 500 }}>
                The watermark will be removed once payment is complete.
              </p>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-md-5">
           { this.template === 'custom' ?
            <CustomWeddingForm reqObject={this.reqObject} handleReqObject={this.handleReqObject} template={this.template} />
            :<WeddingForm reqObject={this.reqObject} handleReqObject={this.handleReqObject} template={this.template} />
           
            }
            </div>
            {this.template === 'classic' ?
              <div id="letters" className="col-md classic-wedding-style myDiv">
                <div className="watermark"></div>
                <Classic reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
              :
              this.template === 'goldDots' ?
              <div id="letters" className="col-md goldDots-wedding-style myDiv">
                <div className="watermark"></div>
                <GoldDots reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
              :
              this.template === 'goldGlitter' ?
              <div id="letters" className="col-md goldGlitter-wedding-style myDiv">
                <div className="watermark"></div>
                <GoldGlitter reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
              :
              this.template === 'silverGlitter' ?
              <div id="letters" className="col-md silverGlitter-wedding-style myDiv">
                <div className="watermark"></div>
                <SilverGlitter reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
              </div>
              :
              this.template === 'marsalaFloral' ?
              <div id="letters" className="col-md marsalaFloral-wedding-style myDiv">
                <div className="watermark"></div>
                <MarsalaFloral reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} isSakura={true} />
              </div>
              :
              this.template === 'wreath' ?
                <div className="col-md wreath-wedding-style myDiv">
                  <div className="watermark"></div>
                  <Wreath reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
                </div>
                :
                this.template === 'modernMinimalist' ?
                <div id="letters" className="col-md modernMinimalist-wedding-style">
                  <ModernMinimalist reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
                </div>
                :
                this.template === 'botanicalSage' ?
                <div id="letters" className="col-md botanicalSage-wedding-style">
                  <BotanicalSage reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
                </div>
                :
                this.template === 'gildedArch' ?
                <div id="letters" className="col-md gildedArch-wedding-style">
                  <GildedArch reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
                </div>
                :
                this.template === 'FloralFrame' ?
                <div className="col-md FloralFrame-wedding-style myDiv">
                  <div className="watermark"></div>
                  <FloralFrame reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} />
                </div>
                :
                this.template === 'custom' ?
                <div className="col-md sakura-wedding-style myDiv">
                  <div className="watermark"></div>
                  <CustomInvitation reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} isSakura={true} />
                </div>
                 :
                 <div className="col-md sakura-wedding-style myDiv">
                   <div className="watermark"></div>
                   <Sakura reqObject={this.reqObject} handleReqObject={this.handleReqObject} isSideBySide={true} isSakura={true} />
                 </div>
            }
          </div>
        </div>
        
      </div>
    );
  }
}

export default SideBySide;